// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';

const StyledSpacer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .separator {
    height: 1px;
    width: 100%;
  }
`;

const Spacer = {
  fields: {
    height: {
      type: 'select',
      options: [
        { label: 'Small', value: '1rem' },
        { label: 'Medium', value: '2rem' },
        { label: 'Large', value: '4rem' },
        { label: 'Extra Large', value: '8rem' },
      ],
    },
    showSeparator: {
      type: 'radio',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    separatorColor: { type: 'text' },
    backgroundColor: { type: 'text' },
  },
  defaultProps: {
    height: '2rem',
    showSeparator: false,
    separatorColor: '#e2e8f0',
    backgroundColor: 'transparent',
  },
  render: ({ height, showSeparator, separatorColor, backgroundColor }) => (
    <StyledSpacer
      style={ { height, backgroundColor } }
    >
      {showSeparator && (
        <div
          className="separator"
          style={ { backgroundColor: separatorColor } }
        />
      )}
    </StyledSpacer>
  ),
};

export { Spacer };
